<script>
    import Customers from '@/services/Customers';
    import Ticketing from '@/services/Ticketing';

    export default {
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                submitted: false,
                tryingToEdit: false,
                showErrorMessage: false,
                showModal: false,
                potentialUserData: [],
                ticketingUserData: [],
                showLoader: false,
            };
        },
        methods: {

            async getTicketingUser(customerNumber){

                await Ticketing.getUserByCrmId(customerNumber)
                    .then((response) => {
                        this.ticketingUserData = response.data.data
                    })
                    .catch(error => {
                        this.ticketingUserData = []
                        this.error = error.response.data.error ? error.response.data.error : "";
                    })
            },

            async getPotentialCustomer(){
                this.showLoader = true;
                await Customers.getPotentialCustomer(this.$route.params.id)
                    .then((response) => {
                        if(response.data.customer.info){
                            this.potentialUserData = response.data.customer.info

                            if(this.potentialUserData.external_id){
                                this.getTicketingUser(this.potentialUserData.external_id)
                            }
                        }
                    })
                    .catch(error => {
                        this.error = error.response.data.error ? error.response.data.error : "";
                    })
                    .finally(() => {
                        this.showLoader = false;
                    })
            },

            async createNewUser(){
                this.tryingToEdit = true
                await Customers.createCustomerFromPotentialData({
                    customer_id: this.$route.params.id,
                })
                .then((response) => {
                    this.successmsg("Customer Created")
                    this.refreshData()
                    this.closeModal()
                }).catch(error => {
                    this.error = error.response.data.error ? error.response.data.error : "Creation Failed !";
                    this.failedmsg(this.error)
                }).finally(() => {
                    this.tryingToEdit = false
                })
            },
            refreshData() {
                this.$emit('onRefresh') //event from parent
            },
            closeModal() {
                this.submitted=  false
                this.tryingToEdit= false
                this.showErrorMessage= false
                this.showModal = false
            },

            resetData(){
                this.potentialUserData = []
            }
        }
    };
</script>

<template>
    <b-modal v-model="showModal" @shown="getPotentialCustomer" @hidden="resetData" id="create_from_potential" title="Create New Customer" title-class="font-18" size="lg" >

        <template v-if="!showLoader">
            <div class="row">
                <div class="col-sm-12 mt-3">
                    <h4>Potential User Data:</h4>
                </div>

               <div class="col-sm-6">
                   <p class="font-size-16 mb-2"><span class="text-strong">Customer ID:</span> {{potentialUserData.id}}</p>
                   <p class="font-size-16 mb-2"><span class="text-strong">First Name:</span> {{potentialUserData.first_name}}</p>
                   <p class="font-size-16 mb-2"><span class="text-strong">Last Name:</span> {{potentialUserData.last_name}}</p>
                   <p class="font-size-16 mb-2"><span class="text-strong">External ID:</span> {{potentialUserData.external_id}}</p>
                   <p class="font-size-16 mb-2"><span class="text-strong">Source:</span> {{potentialUserData.source}}</p>
                </div>
                <div class="col-sm-6">
                    <p class="font-size-16 mb-2"><span class="text-strong">Email:</span> {{potentialUserData.email}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Phone:</span> {{ticketingUserData.phone}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Date Of Birth:</span> {{potentialUserData.date_of_birth}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Gender:</span> {{potentialUserData.gender}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Created On:</span> {{potentialUserData.created_on}}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <p class="font-size-16 mb-2"><span class="text-strong">Street:</span> {{ticketingUserData.street}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Street Number:</span> {{ticketingUserData.street_number}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Postal Code:</span> {{ticketingUserData.postal}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">City:</span> {{ticketingUserData.city}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Country:</span> {{ticketingUserData.country}}</p>
                </div>
                <div class="col-sm-6">
                    <p class="font-size-16 mb-2"><span class="text-strong">Country Iso2:</span> {{ticketingUserData.countryIso2}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Country Iso3:</span> {{ticketingUserData.countryIso3}}</p>
                    <p class="font-size-16 mb-2"><span class="text-strong">Provider:</span> {{ticketingUserData.provider}}</p>
                </div>
            </div>
        </template>
        <div class="card-body d-flex align-items-center justify-content-center" v-else>
            <b-spinner large></b-spinner>
        </div>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="createNewUser" :disabled="tryingToEdit || showLoader">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Create User</b-button>
        </template>
    </b-modal>
</template>